var _defs, _path, _path2, _path3, _path4, _circle, _circle2, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 366.34 366.34",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2d4cf;}.cls-2{fill:#f2a196;}.cls-3{fill:#e88870;}.cls-4{fill:url(#linear-gradient);}.cls-5{fill:none;stroke:#00214e;stroke-miterlimit:10;}.cls-6{fill:#ffffff;}.cls-7{fill:#00214e;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 69.93,
    y1: 286.4,
    x2: 296.41,
    y2: 286.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#16243f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6878b1"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboards_Diversity_Avatars_by_Netguru") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.44,208.43S85.12,200,83.18,199.92c-5-6.76.42-22.1,4.31-28.06,6.74-10.32,18.92-17,22.94-28.66,4.63-13.45-3.12-24.06-4.33-36.78C105,94.35,109.87,82,117.85,73,134,55,160.79,46.08,186.66,46.28c13.5.09,26.74,2.67,38.08,7.7,1.38.61,2.72,1.25,4,1.93,1,.53,2,1.09,3,1.68a75.15,75.15,0,0,1,26.95,27.59c7.91,13.84,9.79,26.67,5.16,42-3,9.82-6.73,20-4.87,30,2,11.05,10.54,20,12.78,31C273.19,194.94,272.14,201.86,270.44,208.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.41,281.75a184.56,184.56,0,0,1-226.48-1l48.66-22.81a46.83,46.83,0,0,0,6.65-3.82c.64-.44,1.28-.9,1.89-1.38a46.35,46.35,0,0,0,12.78-15.09,44.69,44.69,0,0,0,4.64-14.48,67.91,67.91,0,0,0,.74-9.91c0-5.72-.31-11.44-.37-17.17q-.06-4.76-.1-9.51l2,1,5.2,2.69,2.41.41,27.88,4.74,31.12,5.3.94,32,.31,10.46.15,5.08v.33l12.1,4.92Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M214.71,246.19a16,16,0,0,1-10.07-1.56L145,195.85c-.07-2.26-.13.11-.16-2.15q-.06-4.75-.1-9.51l2,1,5.2,2.69,2.41.41,27.88,4.74,31.12,5.3.94,32,.31,10.46.15,5.08v.33Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M296.41,281.75a184.56,184.56,0,0,1-226.48-1l48.66-22.81a46.83,46.83,0,0,0,6.65-3.82c.64-.44,1.28-.9,1.89-1.38,23.55,16.76,55.69,27.33,83.49,14.82,6.62-3,12.7-7.84,16.3-14.06Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 132.97,
    cy: 160.54,
    r: 17
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 138.36,
    cy: 160.29,
    r: 15.22
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.83,144.25,144.89,201c.18,1.46,11,5.74,12.27,6.41C171.66,215,186.59,225.1,203,227.7c7,1.11,14.35,1,21-1.57,11.72-4.5,13.3-13.32,17.32-23.7a184.21,184.21,0,0,0,8.52-28.81c2-9.4,3.78-22.33-3.12-30.39-.84-1-1.74-1.53-1.57-3,1.46-12.32,3.78-26.26-1.59-37.9-3.5-7.57-9.16-13.94-15.37-19.49,0,0-47.23,35.5-51.52,38C166.44,126.71,137.83,144.25,137.83,144.25Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M215.17,141c0,.29,12.66,29.82,12.66,29.82l-15,1.45"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M169.14,128.61a80.61,80.61,0,0,1,28.06-2.11"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M228.28,128.3a55.39,55.39,0,0,1,17.38-2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M191.25,182.07a1.86,1.86,0,0,1,2.66-.62c2.14,1.37,6.08,4.3,11.52,5.13,7.41,1.14,13.67-2.08,15.27-.25.91,1-.08,2.38-2,4.14A19.72,19.72,0,0,1,204,194.81c-7.13-1-12.81-9-12.93-11.88A1.7,1.7,0,0,1,191.25,182.07Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M186.58,139.76c6.09-.27,6.58,9.05.49,9.41h-.27c-6.1.27-6.59-9.05-.49-9.41h.27Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M236.74,136.48c5.65-.25,6.11,8.39.45,8.73h-.25c-5.66.25-6.11-8.39-.46-8.73h.26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar2);
export default __webpack_public_path__ + "static/media/avatar2.8fa355b2b05147304ee1b0d7f5021386.svg";
export { ForwardRef as ReactComponent };